/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import '@ckeditor/ckeditor5-build-classic/build/translations/ar'
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  Switch,
  TextField
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { roleFormValidation } from '../../../../utils/validationSchema'
import { FormLoader } from '../../../Loader/FormLoader'
import { RoleConsumer } from '../../../../RoleContext'
import { NamedRoutes } from '../../../../routes'
import { useStyles } from './Styles'

const RoleForm = ({ currentDate, adminSectionType, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const [selectAllValue, setSelectAllValue] = React.useState(false)
  const toggle = (arrayList, arrayValue) =>
    arrayList.includes(arrayValue)
      ? arrayList.filter(el => el !== arrayValue)
      : [...arrayList, arrayValue]

  const RoleForm = useFormik({
    initialValues: {
      name: currentDate.name || '',
      is_admin_role: !!Object.keys(currentDate).length ? currentDate.is_admin_role : false,
      permissions: currentDate.permissionsIds || []
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: roleFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })
  const [isAdminValue, setIsAdminValue] = React.useState(RoleForm.values.is_admin_role)
  const handleIsAdminChange = (event) => {
    setIsAdminValue(!JSON.parse(event.target.value))
    RoleForm.setFieldValue('is_admin_role', !JSON.parse(event.target.value))
  }

  const handlePermissionChange = (event) => {
    RoleForm.setFieldTouched('permissions', true, true)
    RoleForm.setFieldValue('permissions', toggle(RoleForm.values.permissions, parseInt(event.target.value)))
  }
  const handleAllPermissionChange = (event, permissionsList) => {
    let values = []
    setSelectAllValue(event.target.checked)
    if (!!event.target.checked) {
      values = permissionsList.map(permission => permission.id)
    }
    RoleForm.setFieldTouched('permissions', true, true)
    RoleForm.setFieldValue('permissions', values)
  }

  React.useEffect(() => {
      if ('admin' === currentDate.name) {
        history.push(NamedRoutes.workspace.RolesAndPermissions.list)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentDate])

  return (
    <RoleConsumer>
      {({ permissionsList, permissionsListLoading }) => (
        <form onSubmit={RoleForm.handleSubmit} noValidate autoComplete="off"
              className={classes.formWrapper}>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Role.Name"><FormattedMessage id='Fields.label.RoleName'/></InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'Role.placeholder.RoleName' })}
                id="Role.Name"
                type={'text'}
                margin="dense"
                variant="outlined"
                name='name'
                value={RoleForm.values.name}
                onChange={RoleForm.handleChange}
                onBlur={RoleForm.handleBlur}
                helperText={RoleForm.errors.name && RoleForm.touched.name && RoleForm.errors.name}
                error={RoleForm.errors.name && RoleForm.touched.name !== undefined}
              />
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="Roles.isAdmin"><FormattedMessage id='Roles.List.Table.isAdmin'/>:</InputLabel>
            <FormControl variant="outlined" className={classes.SwitchWrapper}>
              <FormControlLabel
                label={isAdminValue ? intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.Admin' }) : intl.formatMessage({ id: 'Roles.List.Table.isAdmin.Option.NotAdmin' })}
                value={isAdminValue ? true : false}
                control={
                  <Switch color="primary" checked={isAdminValue} value={isAdminValue ? true : false}/>
                }
                onChange={handleIsAdminChange}
              />
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>

            <InputLabel id="Role.Permissions"
                        error={RoleForm.errors.permissions && RoleForm.touched.permissions !== undefined}>
              <FormattedMessage id='Roles.List.Table.Permissions'/>*:</InputLabel>
            <FormControl required error={RoleForm.errors.permissions && RoleForm.touched.permissions !== undefined}
                         component="fieldset" className={classes.formControl}>
              {!!permissionsListLoading && <FormLoader loading={true}/>}
              <FormGroup row>
                <FormControlLabel className={classes.PermissionBox}
                                  control={<Checkbox
                                    color={'primary'}
                                    checked={selectAllValue}
                                    onChange={(event) =>
                                      handleAllPermissionChange(event, permissionsList)}/>}
                                  label={<FormattedMessage id='Permission.SelectAll'/>}
                />
                {permissionsList.map((permission) => (
                  <FormControlLabel key={permission.id} className={classes.PermissionBox}
                                    control={<Checkbox
                                      color={'primary'}
                                      checked={RoleForm.values.permissions.includes(permission.id)}
                                      onChange={handlePermissionChange}
                                      value={permission.id}/>}
                                    label={permission.name}
                  />
                ))}
                {RoleForm.errors.permissions && RoleForm.touched.permissions && (
                  <FormHelperText error={true}>{RoleForm.errors.permissions}</FormHelperText>
                )}
              </FormGroup>
            </FormControl>
          </div>

          <div className={classes.SubmitRow}>
            <button type="submit" disabled={RoleForm.isSubmitting || !RoleForm.isValid}
                    className={classes.AddRoleSubmit}>
              <FormattedMessage id='AdditionalInfo.button.submit'/>
            </button>
            <Button onClick={() => history.push(NamedRoutes[adminSectionType].RolesAndPermissions.list)}
                    color="primary">
              <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
            </Button>
          </div>
          {RoleForm.isSubmitting && <FormLoader loading={true}/>}
        </form>
      )}
    </RoleConsumer>
  )
}

export default RoleForm
